import React, { useState } from 'react';
import { LuPencil, LuTrash2, LuFileText, LuPlus } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { pick } from '../../utils/objectUtils'; // adjust path if needed
import './styles.css';
import { usePermissions } from '../../contexts/PermissionContext';
import {
    CHALLENGE_CATEGORIES,
    CHALLENGE_TYPES,
    CHALLENGE_LEVELS,
    TOURNAMENT_LEVELS
  } from '../../utils/constants';

function ChallengesTable({
  challenges,
  currentPage,
  resultsPerPage,
  onPageChange,
  totalResults,
  setSortOption,
  setSearchTerm,
  onUpdateChallenge,
  onDeleteChallenge,  sortOption,         // ✅ Add this
  searchTerm,         // ✅ Add this
  filters,            // ✅ Add this
  categoryKeywords, // List of known Category keywords from the DB
}) {
  const [editingId, setEditingId] = useState(null);
  const [editedType, setEditedType] = useState('');
  const [editedCategory, setEditedCategory] = useState([]);
  const { permissions } = usePermissions();

  // Pagination logic
  const totalPages = Math.ceil(totalResults / resultsPerPage);

  console.log('Filtered Challenges:', challenges);
  console.log('Current Page:', currentPage);
  console.log('Total Pages:', totalPages);
  console.log('Results Per Page:', resultsPerPage);
  console.log('Permissions:', permissions);

  const fromIndexResults = Math.min((currentPage - 1) * resultsPerPage + 1, totalResults);
  const toIndexResults = Math.min(currentPage * resultsPerPage, totalResults);

  const handleEditClick = (challenge) => {
    setEditingId(challenge.id);
    setEditedType(challenge.type);
    setEditedCategory(challenge.category); // Initialize Category for editing
  };

  const handleSaveClick = (challenge) => {
    console.log('Saving challenge:', challenge);
    console.log('Edited Type:', editedType);
    console.log('Edited Category:', editedCategory);
  
    // First construct the base updated challenge
    const updatedChallenge = {
        ...challenge,
        type: editedType,
        category: editedCategory,
    };
    const payload = pick(updatedChallenge, [
        'name',
        'type',
        'category',
        'tournament_level',
        'level',
        'source_id',
        'tags',
      ]);

    console.log('Payload being sent:', payload);
  
    onUpdateChallenge(challenge.id, payload);
    setEditingId(null); // Exit editing mode
  };

  const handleDeleteClick = (challengeId) => {
    onDeleteChallenge(challengeId);
  };

  const handleAddChallenge = () => {
    // Logic to add a new challenge (e.g., open a modal or inline form)
    console.log('Add new challenge');
  };

return (
    <div className="table-wrapper">
        <div className="filter-sort-section">
            <div className="search-sort-controls">
                <select onChange={(e) => setSortOption(e.target.value)}>
                    <option value="">Sort by...</option>
                    <option value="name">Name</option>
                    <option value="level">Level</option>
                    <option value="tournament_level">Tournament Level</option>
                    <option value="type">Type</option>
                    <option value="Category">Category</option>
                </select>
                <div className="a-size-base a-color-base">
                    {fromIndexResults}-{toIndexResults} of Total Results: {totalResults}
                </div>

                <input
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
        </div>

        {permissions.add_edit_challenges && (
            <button className="add-challenge-button" onClick={handleAddChallenge}>
                <LuPlus style={{ marginRight: '6px' }} /> Add Challenge
            </button>
        )}

        <table className="challenges-table">
            <thead className="table-header a-size-base a-color-base">
                <tr>
                    <th>Name</th>
                    <th>Challenge Level</th>
                    <th>Tournament Level</th>
                    <th>Challenge Type</th>
                    <th>Challenge Category</th>
                    {permissions.add_edit_challenges && <th>Actions</th>}
                </tr>
            </thead>
            <tbody className="table-body">
                {challenges.map((challenge) => (
                    <tr key={challenge.id}>
                        <td>
                            <span className="a-size-base a-color-base">
                            <Link
                            to={{
                                pathname: `/challenges/${challenge.id}`,
                                search: window.location.search
                            }}
                            className="challenge-link"
                            >
                            {decodeURIComponent(challenge.name)}
                            </Link>



                                <a
                                    href={`/pdfs/${challenge.name}.pdf`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="View PDF"
                                >
                                    <LuFileText className="pdf-icon" size={18} />
                                </a>
                            </span>
                        </td>
                        <td>
                            <span className="a-size-base a-color-base">{challenge.level}</span>
                        </td>
                        <td>
                            <span className="a-size-base a-color-base">{challenge.tournament_level}</span>
                        </td>
                        <td>
                            <span className="a-size-base a-color-base">
                                {permissions.add_edit_challenges && editingId === challenge.id ? (
                                    <select
                                        value={editedType}
                                        onChange={(e) => setEditedType(e.target.value)}
                                    >
                                        {CHALLENGE_TYPES.map((type) => (
                                        <option key={type} value={type}>{type}</option>
                                        ))}
                                    </select>
                                ) : (
                                    challenge.type
                                )}
                            </span>
                        </td>
                        <td>
                            <span className="a-size-base a-color-base">
                                {permissions.add_edit_challenges && editingId === challenge.id ? (
                                    <select
                                        value={editedCategory || ''}
                                        onChange={(e) => setEditedCategory(e.target.value)}
                                    >
                                        <option value="">Select Category</option>
                                        {CHALLENGE_CATEGORIES.map((cat) => (
                                        <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                ) : (
                                    challenge.category || 'N/A'
                                )}
                            </span>
                        </td>
                        {permissions.add_edit_challenges && (
                            <td className="actions-column">
                                <span className="a-size-base a-color-base">
                                    {editingId === challenge.id ? (
                                        <button
                                            className="save-button"
                                            onClick={() => handleSaveClick(challenge)}
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <>
                                            <LuPencil
                                                className="edit-icon"
                                                size={18}
                                                onClick={() => handleEditClick(challenge)}
                                            />
                                            <LuTrash2
                                                className="delete-icon"
                                                size={18}
                                                onClick={() => handleDeleteClick(challenge.id)}
                                            />
                                        </>
                                    )}
                                </span>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>

        <div className="pagination-controls">
            <button onClick={() => onPageChange(1)} disabled={currentPage === 1}>
                First
            </button>
            <button
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
            >
                Prev
            </button>
            <span>
                Page {currentPage} of {totalPages}
            </span>
            <button
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
            >
                Next
            </button>
            <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
                Last
            </button>
        </div>
    </div>
);
}

export default ChallengesTable;